module.exports = __webpack_public_path__ + "img/p-logo.e477564b.svg";